import { ReactNode } from 'react';
import { Sidebar } from './Sidebar';
import { AiAssistant } from './AiAssistant';

/**
 * App shell — theo prototype.
 * Sidebar (dark #18212f) trái + main content transparent với max-width 1720px.
 * Header có label "KẾ TOÁN" uppercase + h1 page title + optional subtitle.
 */
export function AppShell({
  children,
  title,
  subtitle,
  hideTitle = false,
}: {
  children: ReactNode;
  title?: string;
  subtitle?: string;
  /** Page có sticky top bar riêng (VD PayrollDetail) → ẩn AppShell header để tránh dup. */
  hideTitle?: boolean;
}) {
  return (
    <div className="app-shell">
      <Sidebar />

      <main className="app-main">
        <div className="app-main-container">
          {!hideTitle && (
            <header className="page-header">
              <p className="page-label">KẾ TOÁN</p>
              <h1 className="page-title">{title}</h1>
              {subtitle && <span className="page-subtitle">{subtitle}</span>}
            </header>
          )}

          <div className="page-content">{children}</div>
        </div>
      </main>
      <AiAssistant />
    </div>
  );
}
